import PvEDoudizhuDemoView from './PvEDoudizhuDemoView';

export {PvEDoudizhuDemoView};